<template>
  <div class="">
    <b-badge v-if="!promoEncerrada" class="countdown-badge" variant="danger">
      <div v-if="!promoEncerrada">
        Encerra em
        <span v-if="dias > 1">{{dias}} dias e </span>
        <span v-if="dias === 1">Amanhã ás </span>
        <span v-if="dias <= 0">Hoje ás </span>
        <span>{{ horas }}:{{ minutos }}:{{ segundos }}</span>
      </div>
    </b-badge>
    <b-badge v-if="promoEncerrada" class="countdown-badge" variant="danger">A Promoção Encerrou!</b-badge>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    segundosAteTermino: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      tempoRestante: moment.duration(this.segundosAteTermino, 'seconds'),
      timer: null,
      promoEncerrada: false,
    };
  },
  computed: {
    dias() {
      return Math.floor(this.tempoRestante.asDays());
    },
    horas() {
      return this.tempoRestante.hours().toString().padStart(2, '0');
    },
    minutos() {
      return this.tempoRestante.minutes().toString().padStart(2, '0');
    },
    segundos() {
      return this.tempoRestante.seconds().toString().padStart(2, '0');
    },
  },
  methods: {
    iniciarTemporizador() {
      this.timer = setInterval(() => {
        if (this.tempoRestante.asSeconds() <= 0) {
          clearInterval(this.timer);
          this.promoEncerrada = true;
        } else {
          this.tempoRestante.subtract(1, 'second');
        }
      }, 1000);
    },
  },
  mounted() {
    this.iniciarTemporizador();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
.countdown-timer {
  margin-top: 20px;
  width: 100%;
}

.countdown-badge {
  position: absolute;
  top: 10px;
  left: 0;
}

.countdown-item {
  display: inline-block;
  margin: 0 10px;
  font-size: 0.8ren;
}
</style>
